import localeService from 'commons/localeService/localeService';
import { PUBLISHING_SCOPE } from 'commons/publishing/publishingScope';

/**
 * Where sample orders are switched on — the staged rollout, release-time constants by design.
 * See `docs/publishing/sample-order-journey.md` §2.
 */
export const ALL_LOCALES = 'ALL';

export type SampleOrderLocales = readonly string[] | typeof ALL_LOCALES;

/**
 * Every locale: each one the partner area resolves has a sample shop of its own, priced in its own
 * currency. A new locale needs both before it goes live, or it orders through the fallback shop.
 * See `docs/publishing/sample-order-journey.md` §2.
 */
export const SAMPLE_ORDER_LOCALES: SampleOrderLocales = ALL_LOCALES;

/** Both channels, each through sample shops of its own (see `sampleOrderShops.ts`). */
export const SAMPLE_ORDER_SCOPES: readonly string[] = [
  PUBLISHING_SCOPE.SHOP.key,
  PUBLISHING_SCOPE.MP.key,
];

/** The lists are arguments so the rules stay testable without a domain to run on. */
export const isSampleOrderLocale = (
  locale: string | undefined,
  locales: SampleOrderLocales = SAMPLE_ORDER_LOCALES,
): boolean => locales === ALL_LOCALES || (!!locale && locales.includes(locale));

export const isSampleOrderScope = (
  scopeKey: string | undefined,
  scopes: readonly string[] = SAMPLE_ORDER_SCOPES,
): boolean => !!scopeKey && scopes.includes(scopeKey);

/** For entry points that pick a scope only later. */
export const sampleOrderAvailable = (): boolean =>
  isSampleOrderLocale(localeService.getLocale());

/** For an entry point that already stands in a scope. */
export const sampleOrderAvailableInScope = (
  scopeKey: string | undefined,
): boolean => sampleOrderAvailable() && isSampleOrderScope(scopeKey);
